import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'
import { IoPricetagsSharp } from 'react-icons/io5'
import { user_get_single_submission } from '../../redux/actions/submissionActions'
import { USER_GET_SUBMISSION_DETAILS_RESET } from '../../redux/types'
import Loader from '../../components/Loader'
import { DateTime } from 'luxon'
import { comma } from '../../utils/helper'

const UserDashboardSubmissionDetails = () => {
	const dispatch = useDispatch()

	const params = useParams()

	const userGetSubmissionDetail = useSelector(
		(state) => state.userGetSubmissionDetail
	)
	const { loading, userSubmissionDetail } = userGetSubmissionDetail

	useEffect(() => {
		dispatch(user_get_single_submission(params.slug))

		return () => {
			dispatch({ type: USER_GET_SUBMISSION_DETAILS_RESET })
		}
	}, [dispatch])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : userSubmissionDetail ? (
					<div className='container'>
						<div className='row mb-3'>
							<div className='col-md-7'>
								<h1 className='page_header'> {userSubmissionDetail.title} </h1>
								<p>
									{userSubmissionDetail.subTitle &&
										userSubmissionDetail.subTitle}
								</p>

								<p>
									Date Submitted:{' '}
									{DateTime.fromISO(
										userSubmissionDetail.createdAt
									).toLocaleString(DateTime.DATETIME_MED)}
								</p>
							</div>
							<div className='col-md-5 text-rightt'>
								<div className='d-flex justify-end'>
									<p className='mr-4'>
										<IoPricetagsSharp /> {userSubmissionDetail.category}
									</p>
									<p>
										{userSubmissionDetail.status == 'In Review' ? (
											<div>
												<p>
													<span className='yellow_dot dot_dot'></span>{' '}
													{userSubmissionDetail.status}
												</p>
											</div>
										) : userSubmissionDetail.status == 'Rejected' ? (
											<div>
												<p>
													<span className='red_dot dot_dot'></span>{' '}
													{userSubmissionDetail.status}
												</p>
											</div>
										) : userSubmissionDetail.status == 'Accepted' ? (
											<div>
												<p>
													<span className='green_dot dot_dot'></span>{' '}
													{userSubmissionDetail.status}
												</p>
											</div>
										) : (
											<div>
												<p>
													<span className='black_dot dot_dot'></span>{' '}
													{userSubmissionDetail.status}
												</p>
											</div>
										)}
									</p>
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-4 col-sm-6'>
								<img
									src={userSubmissionDetail.image}
									alt=''
									className='img-fluid mb-4'
								/>
								<h5 className='desc'>
									<strong>Bank Details</strong>
								</h5>
								<p>
									<strong>Bank Name:</strong> {userSubmissionDetail.bank}
								</p>
								<p>
									<strong>Account Name:</strong>{' '}
									{userSubmissionDetail.accountName}
								</p>
								<p>
									<strong>Account Number:</strong>
									{userSubmissionDetail.accountNumber}
								</p>
								<h5 className='desc'>
									<strong>Other Details</strong>
								</h5>
								<p>
									<strong>Asking Amount:</strong> &#8358;
									{comma(userSubmissionDetail.askingAmount)}
								</p>
								<p>
									<strong>Location:</strong> {userSubmissionDetail.location}
								</p>
								{userSubmissionDetail.rewards !== '' ? (
									<p>
										<strong>Rewards:</strong> {userSubmissionDetail.rewards}
									</p>
								) : null}

								<p>
									<strong>Campaign: </strong>
									{userSubmissionDetail.submissionRound &&
										userSubmissionDetail.submissionRound.name}
								</p>
								{userSubmissionDetail.approvedAmount && (
									<p>
										<strong>Approved Amount:</strong> &#8358;
										{comma(userSubmissionDetail.approvedAmount)}
									</p>
								)}
							</div>

							<div className='col-md-8 col-sm-6'>
								<div className='d-flex'>
									<p className='mr-1'>Script: </p>
									<a
										target='_blank'
										rel='noreferrer'
										download
										href={`https://feemfundy.herokuapp.com${userSubmissionDetail.scriptLink}`}
									>
										Click here to view
									</a>
								</div>
								{userSubmissionDetail.video ? (
									<div className='d-flex'>
										<p className='mr-1'> Video: </p>
										<a
											target='_blank'
											rel='noreferrer'
											href={`${userSubmissionDetail.video}`}
										>
											Click here to view video
										</a>
									</div>
								) : null}

								<h5 className='desc'>
									<strong>Description</strong>
								</h5>
								<p>{userSubmissionDetail.description}</p>
							</div>
						</div>
					</div>
				) : (
					<p>Nothing to display</p>
				)}
			</section>
		</>
	)
}

export default UserDashboardSubmissionDetails
